module.exports = __webpack_public_path__ + "static/media/planta-de-tratamiento-al-fondo-los-relaves.9e86a134.jpg";